import { render, staticRenderFns } from "./GoogleDocActions.vue?vue&type=template&id=0f985969&scoped=true&"
import script from "./GoogleDocActions.vue?vue&type=script&lang=js&"
export * from "./GoogleDocActions.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDocActions.vue?vue&type=style&index=0&id=0f985969&prod&lang=scss&scoped=true&"
import style1 from "./GoogleDocActions.vue?vue&type=style&index=1&id=0f985969&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f985969",
  null
  
)

export default component.exports